module.exports = __webpack_public_path__ + "img/product-banner5.f3ab51f9.jpg";